export class ChangeSet {
    public id: number;
    public name: string;
    public description: string;
}